import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

// helpers
import { capitalizeFirstLetter } from 'src/helpers/text-format'

const AppDetails = ({
  contactDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Profile name"
          className='mb-3'
          subtitle={contactDetails?.profile_name ? capitalizeFirstLetter(contactDetails?.profile_name) : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Company name"
          className='mb-3'
          subtitle={contactDetails?.company_name ? capitalizeFirstLetter(contactDetails?.company_name) : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Phone Number"
          className='mb-3'
          subtitle={contactDetails?.wa_id ? `${contactDetails?.wa_id}` : '-'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
